// webkey 与appkey的映射关系 只能映射纯文字的多语言文案，暂时无法映射传参形式文案
export default {
  // 公共
  thread: 'nova_community_tab_thread',
  cancel: 'nova_community_dialog_un_follow_cancel',
  discardEdit: 'nova_community_edit_exit_tips',
  discard: 'nova_community_edit_exit_yes',
  author: 'user_tag_author',
  // page: '页',
  // jan: '01-',
  // feb: '02-',
  // mar: '03-',
  // apr: '04-',
  // may: '05-',
  // jun: '06-',
  // jul: '07-',
  // aug: '08-',
  // sep: '09-',
  // oct: '10-',
  // nov: '11-',
  // dec: '12-',
  // january: '一月',
  // february : '二月',
  // march : '三月',
  // april: '四月',
  // june: '六月',
  // july: '七月',
  // august: '八月',
  // september: '九月',
  // october: '十月',
  // november: '十一月',
  // december: '十二月',
  noContent: 'no_content',
  loadingFailed: 'load_failed',
  noResult: 'nova_community_blank_no_search_result',
  send: 'dialog_send',
  justNow: 'nova_community_time_now',
  // ago: '前',
  // min: '分钟',
  // today: '今天',
  // left: '后结束',
  // day: '天', // ...
  // hour: '小时',
  // minute: '分钟',
  loading: 'loading',
  finished: 'all_loaded',
  error: 'load_failed',
  // vote: '票', // ...
  // pullRefresh: '下拉刷新',
  // releaseRefresh: '松开刷新',
  noMore: 'all_loaded',
  // goBack: '返回',
  // tryAgain: '',
  sthWrong: 'nova_community_message_server_error',
  // ohNo: '',
  // inCorrectImageFormat: '不支持的图片格式',
  errorNetwork: "no_network",
  requestError: 'error_network_Request_timed_out',
  // fileValidate: '您只能上传 {type}.',
  // sizeValidate: '不支持上传大于{size}的视频。',
  videoTypeValidate: 'publisher_video_out_format_tips',
  latestActivity: 'nova_community_sort_by_newly_activity',
  latestCreated: 'nova_community_sort_by_newly_post',
  // bottomCookie: '我们会使用Cookie和类似相关技术来使本网站正常操作运行，并分析流量及优化您的浏览体验。继续浏览该网站，即表示您同意使用此类cookie。',
  // readMore: '阅读更多',
  // oppoCopyRight: 'Copyright © 2004-2022 OPPO. All rights reserved.',
  // oneplusCopyRight: '© 2013-2021 深圳市万普拉斯科技有限公司 版权所有( 粤ICP备13080605号 )',
  none: 'circle_flair_none',
  // reload: '重新加载',
  loginFail: 'nova_community_login_failed',
  // logoutFail: '退出登录失败，请重试',
  success: 'nova_community_success',
  // fail: '失败',
  marked: 'nova_community_menu_bookmark',
  // openApp: '使用一加社区App打开',
  // openStore: '是否打开应用商店下载一加社区App?',
  yes: 'nova_community_yes',
  
  // 首页
  home: 'main_bottom_nav_menu_home',
  myCircles: 'nova_community_my_circles_title',
  allCircles: 'nova_community_label_all_circles',
  // store: 'OPPO商城',
  // newThread: '发动态',
  // oneplus: '一加社区',
  explore: 'nova_tab_home_explore',
  hotTopics: 'nova_community_label_search_trending',
  topCreators: 'explore_top_creator_title',
  activeRanking: 'explore_active_ranking_title',
  recommended: 'explore_small_banner_title',
  myProfile: 'personal_space_name',
  logOut: 'nova_community_menu_logout',
  logIn: 'nova_community_login_or_register',
  myDraft: 'nova_community_menu_drafts',
  noMoreThread: 'all_loaded',
  notJoinThisCircle: 'nova_community_publisher_publish_no_joined_hints',
  myFollowing: 'nova_tab_home_following',
  posts: 'nova_community_profile_tab_posts',
  // homeTitle: '',
  noFollow: 'nova_community_text_no_following',
  noFollowContent: 'nova_community_text_no_event',
  joinNewCircles: 'circle_recommend_title',
  // dayCount: `{n} 天`, // ...
  mark: 'nova_community_menu_bookmark',
  unMark: 'nova_community_menu_unmarked',


  // 圈子
  // updates: '{n}条新动态',
  join: 'nova_community_button_text_join',
  pending: 'nova_community_circle_join_btn_pending',
  ownBy: 'nova_community_circle_owner',
  // members: '圈友',
  requests: 'nova_community_label_request',
  decline: 'decline',
  accept: 'accept',
  confirmQuitCircle: 'nova_community_quite_circle_message',
  confirmQuit: 'nova_community_yes',
  quitCircle: 'exit_circle',
  quit: 'quit',
  owner: 'home_my_circle_owner_text',
  circleOwner: 'home_my_circle_owner_text',
  // circleMember: '圈友', // ...
  circleAssistant: 'nova_community_title_name_assistant',
  circleAdministrators: 'nova_community_label_circle_administrator',
  circleName: 'nova_community_label_circle_name',
  circleNamePlaceholder: 'nova_community_circle_name_hint',
  circleIntroduction: 'nova_community_label_circle_introduction',
  circleIntroductionPlaceholder: 'nova_community_circle_introduction_hint',
  createReason: 'nova_community_label_application_reason',
  createReasonPlaceholder: 'nova_community_application_reason_hint',
  circlePermissionType: 'nova_community_label_join_permission',
  everyoneCanJoin: 'nova_community_circle_join_without_permission',
  notEveryoneCanJoin: 'nova_community_circle_join_with_permission',
  addCover: 'nova_community_create_circle_add_cover',
  notJoinCircle: 'no_join_circle',
  createCircle: 'nova_community_label_new_circle',
  createCircleTitle: 'nova_community_label_new_circle',
  // circleNameHasBeenUsed: '圈子名已被占用，请换一个',
  // needSelectCircleAttribute: '请设置圈子权限',
  circleManageTitle: 'nova_community_label_manage_members',
  editCircle: 'edit_circle',
  checkMyCircle: 'un_login',
  submitApplication: 'nova_community_action_report_submit',
  remove: 'nova_community_action_remove_from_circle',
  setAssistant: 'nova_community_action_set_assistant',
  setAssistantTitle: 'nova_community_action_set_assistant',
  // setAssistantContent: '确认设置副圈主？?',
  cancelAssistantTitle: 'nova_community_action_set_civilian',
  // cancelAssistantContent: '确认取消副圈主？',
  confirmAssistant: 'nova_community_yes',
  removeAssistant: 'nova_community_action_set_civilian',
  // requestSend: '申请加入',
  removeMember: 'nova_community_action_remove_from_circle',
  removeMemberTitle: '确认移除该圈友？',
  submitted: 'nova_community_circle_wait_for_review',
  // submittedContent: '您的加入申请圈主正在审核中',
  // submittedTeamContent: '您的申请社区正在审核中',
  // ciecleEditReview: '你的编辑正在审核中',
  // needJoinCircle: '请先加入该圈子',
  manageUser: 'manage_circle',
  circleRequest: 'nova_community_label_request',
  // threads: '帖子',
  // threadsFromCircle: '动态',
  // engagement: '互动',
  viewAll: 'text_view_all_my_joined_circle',
  all: 'circle_tab_all_text',
  recent: 'nova_community_label_mention_recent',
  // allCircleTitle: '',
  // myCircleTitle: '',
  // circleDetailTitle: '',
  joined: 'nova_community_button_text_joined',
  joinSuccess: 'all_circle_list_joined_hint',
  quiteInAllCircle: 'nova_community_quite_circle_message',

  // 帖子详情
  moment: 'nova_community_label_publisher_moment',
  article: 'nova_community_label_publisher_article',
  poll: 'nova_community_label_publisher_poll',
  feedBack: 'nova_community_label_publisher_feed_back',
  // lastEdit: '最后更新于', // ...
  message: 'nova_community_message_title_message',
  share: 'nova_community_menu_share',
  // orCopyLink: '或者复制链接',
  // allComments: '所有评论', // ...
  mostLike: 'nova_community_sort_by_heat',
  latest: 'nova_community_sort_by_default',
  earliest: 'nova_community_sort_by_time',
  // reply: '回复',
  pollShut: 'nova_community_poll_closed',
  pollTag: 'nova_community_label_publisher_poll',
  addComment: 'nova_community_article_input_comment_hint',
  report: 'nova_community_menu_report',
  edit: 'nova_community_menu_edit',
  delete: 'nova_community_delete',
  copyLink: 'nova_community_menu_copy_link',
  stick: 'nova_community_menu_sticky',
  cancelStick: 'nova_community_menu_turn_off_sticky',
  // copySuccess: '链接已复制',
  // closeComment: '这条动态关闭了评论/回复权限',
  closeCommentSimple: 'nova_can_not_comment',
  submit: 'nova_community_action_report_submit',
  reportPlacement: 'nova_community_action_report_reason_hint',
  // comment: '评论',
  // replyTo: '回复',
  // wordLimit: '您只能输入 {wordLimit} 字',
  // imgUploading: '图片上传中',
  // mute: '您因为违法社区条款 & 条件而被禁言',
  deleteCommentReply: '该评论已被删除',
  commentDeleted: '该评论已被删除',
  // uploadFailed: '上传失败！',
  // viewAllReplies: '查看所有 {n} 条回复',
  confirmVoteTitle: 'nova_community_title_confirm_to_vote',
  voteConfirm: 'nova_community_yes',
  noMoreComment: 'all_loaded',
  noMoreReply: 'all_loaded',
  // copy: '复制',
  // replyCopySuccess: '{type} 复制成功',
  profile: 'circle_profile_title_text',
  // mightBeLike: '你可能也喜欢...',
  sureDelete: 'nova_community_dialog_title_remove_content',
  quote: "nova_community_menu_quote",
  reportSuccess: 'nova_community_submitted_successfully',

  // 发帖
  // chooseCircle: '选择一个已加入的圈子',
  // editorPlaceholder: '与百万加油分享你的想法、感受和故事…',
  title: 'nova_community_publisher_article_title_hint',
  uploadVideo: 'publisher_article_video_local',
  addYoutube: 'publisher_article_video_youtube',
  youtubePlaceholder: 'publisher_article_video_youtube',
  ok: 'nova_community_menu_confirm',
  // option: '选项', // ...
  addOption: 'publisher_poll_add_text',
  closeTips: 'publisher_poll_timer_text',
  resetCloseTime: 'publisher_poll_timer_reset_text',
  notReset: 'publisher_poll_option_not_reset_timer_tips',
  post: 'nova_community_button_join_topics',
  linkValidate: 'nova_community_add_link_illegal_url',
  // incorrectFormat: '不正确的格式',
  selectCircle: 'circle_recommend_select_tips',
  titleValidate: 'publisher_publish_input_title_tips',
  // contentValidate: '请输入至少1个字符',
  // pictureLimit: '您只能上传最多{limit}张图片',
  // uploading: '{type} 上传中',
  // video: '视频',
  // image: '图片',
  chooseACircle: 'dialog_choose_circle_title',
  // pollContentValidate: '投票帖选项中必须输入文字',
  // pollNumValidate: '投票帖最少添加2个选项',
  // selectDay: '请选择投票结束期限',
  // small: '小',
  // default: '默认',
  // medium: '中',
  // large: '大',
  // superLink: '超链接',
  // atSomeBd: '@某人',
  // uploadImage: '图片上传',
  // draftSaved: '草稿已保存',
  // draftSaving: '草稿保存中...',
  saveEdit: 'publisher_publish_exit_tips',
  saveDraft: 'publisher_publish_exit_ok',
  discardDraft: 'nova_community_edit_exit_yes',
  // publishTitle: '',
  addFlair: 'circle_flair_add',
  resumeDraft: 'nova_community_publisher_restore_draft_tips',
  resume: 'nova_community_publisher_restore_draft_recover',
  preview: 'nova_community_menu_publisher_article_preview',
  myprofileTips: 'publisher_select_profile_circle_hint',
  recommendCircleTips: "publisher_select_recommend_circle_hint",
  needContent: 'nova_community_publisher_content_empty',

  // 搜索
  trends: 'nova_community_label_search_trending',
  history: 'nova_community_label_history',
  clearHistory: 'nova_community_button_clear',
  circle: 'nova_community_tab_circle',
  user: 'nova_community_tab_user',
  confirmClearHistory: 'nova_community_confirm_clear_history',
  confirmClear: 'nova_community_button_clear',
  search: 'nova_community_discover_search_query_hint',
  searchUserName: 'nova_community_mention_member_search_hint',
  searchUserNameValidate: 'nova_community_mention_member_search_hint',
  addLink: 'nova_community_add_link_page_title',
  text: 'nova_community_publisher_article_title_hint',
  link: 'nova_community_add_link_url_hint',
  // searchInside: '在 “{circleName}” 中搜索',
  // searchCircle: '在此圈子中搜索',
  mostRelevant: 'nova_community_search_sort_most_relevant',
  mostViewed: 'nova_community_search_sort_most_viewed',
  mostCommented: 'nova_community_search_sort_most_commented',
  allTime: 'nova_community_search_range_all_time',
  pastWeek: 'nova_community_search_range_past_week',
  pastMonth: 'nova_community_search_range_past_month',
  pastYear: 'nova_community_search_range_past_year',

  //个人详情
  name: 'profile_edit_user_name_text',
  userThreads: 'nova_community_tab_thread',
  unreleasedPost: 'nova_community_menu_drafts',
  userLikes: 'nova_community_profile_tab_likes',
  save: 'dialog_save',
  nameChangeLimit: 'profile_edit_user_name_tips',
  // alreadChangeName: '您的修改昵称次数已用尽',
  // userNameValidate: '请输入昵称',
  editUserName: 'nova_dialog_edit_nick',
  aboutUs: 'nova_community_menu_about',
  confirmLogOut: 'nova_community_confirm_logout',
  bio: 'profile_edit_user_sign_text',
  editBio: 'nova_dialog_edit_sign',
  editAvatar: 'CropFragment',
  setting: 'nova_title_setting',
  // lastActivities: '最后活跃',
  // userlTitle: '',
  profileLinkCopied: 'copy_user_link_toast',
  delDraft: 'draft_list_delete_tips',
  noTitle: 'draft_list_default_content_text',
  block: 'nova_community_menu_block',
  unblock: 'user_unblock',
  blockTips: 'block_dialog_content',
  privacy: 'nova_community_menu_privacy',
  blockList: 'nova_community_menu_block_list',
  blockContentTips: "user_block",
  blockedContentTips: "user_blocked",
  myposts: 'nova_community_profile_tab_posts',
  // language: '多语言',
  
  reviewing: 'profile_thread_reviewing_text',
  notApproved: 'profile_thread_review_not_approved_text',
  // done: '完成',

  // 话题
  hotTopicList: 'nova_community_trending_topic_title',
  latestTopic: 'nova_community_topics_list_subtitle',
  unJoinTopic: 'nova_community_dialog_title_unfollow_topic',
  topicMax: 'more_than_two_topic_tips',
  more: 'nova_community_medal_more',
  hotTopic: 'nova_community_trending_topic_title',
  // views: '浏览', // ...
  myCollect: 'nova_community_topic_tab_following',
  joinTopic: 'nova_community_menu_publisher_article_post',
  addTopicTitle: 'nova_community_title_add_topic',
  searchTopic: 'nova_community_search_topic_hint',
  allTopic: 'nova_community_all_topic_button',
  allTopics: 'nova_community_topic_tab_all',

  // 关注
  following: 'nova_community_button_following',
  follow: 'nova_community_button_follow',

  
  // 系统
  notification: 'nova_community_message_title_notifications',
  activities: 'nova_community_message_title_activities',
  messages: 'nova_community_message_title_message',
  // checkSystem: '请登录后查看消息',
  contentDelete: 'nova_community_message_comment_deleted',
  contentReview: 'profile_thread_reviewing_text',
  contentReject: 'profile_thread_review_not_approved_text',
  threadDelete: 'nova_community_message_thread_deleted',
  social: 'main_bottom_nav_menu_social',
  noTextContent: 'nova_community_message_picture_thread',
  commentAreplies: 'activities_message_type_comments',
  // socialTitle: '',
  deleteChat: 'nova_community_delete_conversation',
  deleteMsg: 'nova_community_delete_msg',
  topicDelete: 'nova_community_topic_deleted',
  loginTips: 'nova_community_login_continue',

  //协议相关
  privacyPolicy: 'nova_community_about_policy',
  termsConditions: 'nova_community_menu_terms',
  userAgreement: 'community_user_agreement',
  // useOfCookies: 'Use Of Cookies',
  // cookiesStatement: 'Cookies Statement',
  privacyNotice: 'nova_community_about_policy',
  termsOfUse: 'nova_community_menu_terms',
} 